import { DatePickerDropdown } from '@xo-union/tk-component-datepicker';
import { FieldProps } from 'formik';
import moment from 'moment';
import React from 'react';

import DateDropdownField from './DateDropdownField';

import styles from './dateDropdown.scss';

export interface DateDropdownProps extends FieldProps {
  label?: string | null;
  returnedDateFormat?: string;
  displayedDateFormat?: string;
  readOnly?: boolean;
  isOutsideRange?: (momentDate: moment.Moment) => boolean;
}

export const DateDropdown: React.FC<DateDropdownProps> = ({
  label,
  field,
  form,
  returnedDateFormat = 'YYYY-MM-DD',
  displayedDateFormat = 'MMMM DD, YYYY',
  readOnly = true,
  isOutsideRange,
  ...rest
}) => {
  const { name, value: date } = field;
  const { setFieldValue } = form;
  const momentDate = moment.utc(date, returnedDateFormat, true);
  const onDateChange = (dt: moment.Moment | string): void => {
    if (moment.isMoment(dt)) {
      const formattedDate = dt.format(returnedDateFormat);
      setFieldValue(name, formattedDate);
    } else {
      setFieldValue(name, dt);
    }
  };

  return (
    <div className={`${styles.container} ${readOnly ? '' : styles.withPlaceHolder}`}>
      <DatePickerDropdown
        date={momentDate.isValid() ? momentDate : null}
        dateFormat={displayedDateFormat}
        onDateChange={onDateChange}
        isOutsideRange={isOutsideRange}
        // @ts-ignore
        renderInput={(props): JSX.Element => (
          <DateDropdownField
            readOnly={readOnly}
            name={name || 'date'}
            label={label || 'Date'}
            onChange={onDateChange}
            form={form}
            {...props}
            {...rest}
          />
        )}
      />
    </div>
  );
};
